module.exports = __webpack_public_path__ + "img/user_brown.de6c5083.svg";